exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-3587c928],th[data-v-3587c928]{width:190px;max-width:190px;min-width:190px}", ""]);

// exports
